//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            gameStarted: false,
            gamePaused: false,
            activeRoundIndex: 0,
            defaultTime: 10,
            interval: -1,
            rounds: [],
            lightSwitches: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            fullRooms: [{
                image: '/images/game/w3d4/room_full_1.png',
                needsLight: true
            }, {
                image: '/images/game/w3d4/room_full_2.png',
                needsLight: true
            }, {
                image: '/images/game/w3d4/room_full_3.png',
                needsLight: true
            }, {
                image: '/images/game/w3d4/room_full_4.png',
                needsLight: true
            }, {
                image: '/images/game/w3d4/room_full_5.png',
                needsLight: true
            }]
        };
    },

    computed: {
        activeRound () {
            return this.rounds[this.activeRoundIndex];
        },
        lastRound () {
            return this.activeRoundIndex === this.rounds.length - 1;
        },
        result () {
            let numCorrect = this.rounds.filter(round => round.solved).length;

            return this.$game.getDragDropResult(numCorrect, this.rounds.length - numCorrect);
        }
    },

    created () {
        let numRounds = 5;

        for (let index = 0; index < numRounds; index++) {
            // get 2 or 3 full rooms
            let rooms = _.shuffle(this.fullRooms).slice(0, Math.random() < 0.5 ? 3 : 2);

            // fill up other rooms with empty rooms
            for (let index = rooms.length; index < this.lightSwitches.length; index++) {
                rooms.push({
                    image: '/images/game/w3d4/room_empty_light.png',
                    needsLight: false
                });
            }

            this.rounds.push({
                seconds: this.defaultTime,
                solved: false,
                rooms: _.shuffle(rooms)
            });
        }
    },

    destroyed() {
        clearInterval(this.interval);
    },

    methods: {
        startGame () {
            this.randomizeLightSwitches();
            this.startCounter();
            this.gameStarted = true;
        },
        completeRound () {
            clearInterval(this.interval);
            this.gamePaused = true;

            this.activeRound.solved = !this.lightSwitches.some((switchedOn, index) => {
                let room = this.activeRound.rooms[index];

                return room.needsLight && !switchedOn || !room.needsLight && switchedOn;
            });

            if (this.lastRound) {
                this.showNext = true;
            }
        },
        nextRound () {
            if (!this.lastRound) {
                this.activeRoundIndex++;
                this.randomizeLightSwitches();
                this.startCounter();
                this.gamePaused = false;
            }
        },
        startCounter () {
            this.interval = setInterval(() => {
                this.activeRound.seconds--;
                if (this.activeRound.seconds === 0) {
                    this.completeRound();
                }
            }, 1000);
        },
        randomizeLightSwitches () {
            do {
                this.lightSwitches = this.activeRound.rooms.map(room => room.needsLight || Math.random() < 0.5);
            } while (this.lightSwitches.filter(switchedOn => switchedOn).length < 5);
        }
    }
};
